import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  dashboardPage: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gridTemplateRows: 'repeat(5, minmax(8rem, 1fr))',
    gap: '1.5rem',
    height: '100%',
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(14, minmax(200px, 1fr))'
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(11, minmax(auto, 300px))'
    }
  },
  dashboardMediumItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 2',
    gridColumn: 'span 1',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 4'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1',
      minHeight: '18rem'
    }
  },
  dashboardLargeItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 2',
    gridColumn: 'span 2',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 4'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1',
      minHeight: '18rem'
    }
  },
  dashboardSmallItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 1',
    gridColumn: 'span 1',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 1'
    }
  }
}));

export default useStyles;
